/* /assets/mix-match-set.js
   Complete the Set: adds two existing product variants to the cart in a
   single request. No new SKU, no new inventory — uses the merchant's
   existing variant IDs only.

   Two rendering modes share the same cart-add/event logic below:
   - single mode  (data-mms-mode absent/"single"): cross-sell block on a real
     product's own page — reads that product's own currently selected variant
     from the native product form, plus one partner size picker.
   - dual mode    (data-mms-mode="dual"): standalone presentation product
     (e.g. "CORT SET") with no sellable variant of its own — two explicit
     size pickers (top/bottom), both required. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    var token = match ? match[1] : 'amount';
    var formatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    if (token === 'amount_no_decimals') {
      formatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    return format.replace(placeholder, formatted);
  }

  function getCurrentVariantId() {
    var input = document.querySelector('form[data-product-form] input[name="id"]');
    return input ? parseInt(input.value, 10) : null;
  }

  /* Shared cart-add: posts both variant ids in one /cart/add.js request,
     then updates the header cart count and opens the cart drawer via the
     theme's existing cart events — reused by both single and dual mode. */
  function submitSetToCart(variantIdA, variantIdB, ui) {
    ui.setLoading(true);
    if (ui.errorEl) ui.errorEl.style.display = 'none';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [
          /* The leading underscore makes this a hidden line item property:
             invisible to the customer in cart/checkout, but visible on the
             order in Admin and readable by a cart/discount Shopify Function
             later, to tell a bundle-button add apart from a coincidental
             manual purchase of both products. */
          { id: variantIdA, quantity: 1, properties: { _cort_set_bundle: 'cort-set' } },
          { id: variantIdB, quantity: 1, properties: { _cort_set_bundle: 'cort-set' } }
        ]
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw err;
          });
        }
        return response.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('theme:cart:change', {
            detail: { cart: cart },
            bubbles: true
          })
        );
        /* Two real variants were added in one request, so there is no single
           "the" variant to hand to theme:cart:popdown (its listener expects
           event.detail.variant.id and throws on null, which silently aborts
           before the drawer ever opens). Open the existing cart drawer
           directly instead, the same event the theme's own "view cart"
           button inside the popdown already uses. */
        var cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
        if (cartDrawer) {
          cartDrawer.dispatchEvent(
            new CustomEvent('theme:drawer:open', { bubbles: false })
          );
        }
        ui.setLoading(false);
      })
      .catch(function (err) {
        ui.setLoading(false);
        var message =
          (err && err.description) ||
          (err && err.message) ||
          'Set konnte nicht hinzugefügt werden. Bitte erneut versuchen.';
        ui.showError(message);
      });
  }

  function makeUi(root) {
    var addButton = root.querySelector('[data-mms-add-button]');
    var addButtonText = root.querySelector('[data-mms-add-button-text]');
    var spinner = addButton ? addButton.querySelector('.svg-loader') : null;
    var errorEl = root.querySelector('[data-mms-error]');
    var readyText =
      (addButton && addButton.getAttribute('data-mms-ready-text')) ||
      (addButtonText ? addButtonText.textContent : 'Set in den Warenkorb');

    return {
      addButton: addButton,
      errorEl: errorEl,
      isSubmitting: false,
      /* Dual mode (CORT SET) calls this while the two sizes aren't both
         picked yet. Single mode never calls it, so its button text is
         unaffected. */
      setIncomplete: function () {
        if (addButtonText) addButtonText.textContent = 'Bitte beide Größen auswählen';
      },
      setReady: function () {
        if (addButtonText) addButtonText.textContent = readyText;
      },
      setLoading: function (isLoading) {
        this.isSubmitting = isLoading;
        addButton.disabled = isLoading;
        if (spinner) {
          /* Dual mode has a spinner element — hide the label, show the
             spinner via CSS (.mms__add-btn.is-loading in theme.css). */
          addButton.classList.toggle('is-loading', isLoading);
        } else if (addButtonText) {
          /* Single mode (cross-sell block) has no spinner markup — keep the
             original text-swap behaviour so it stays unchanged. */
          addButtonText.textContent = isLoading ? 'Wird hinzugefügt …' : readyText;
        }
      },
      showError: function (message) {
        if (!errorEl) return;
        errorEl.textContent = message;
        errorEl.style.display = 'block';
        setTimeout(function () {
          errorEl.style.display = 'none';
        }, 5000);
      }
    };
  }

  function readOption(btn) {
    return {
      variantId: parseInt(btn.getAttribute('data-variant-id'), 10),
      price: parseInt(btn.getAttribute('data-price'), 10),
      sku: btn.getAttribute('data-sku'),
      title: btn.getAttribute('data-title')
    };
  }

  function bindSizePicker(container, onSelect) {
    var options = container.querySelectorAll('[data-mms-size-option]');
    options.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        options.forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        onSelect(readOption(btn));
      });
    });
    return options;
  }

  /* Single mode: cross-sell block on a real product's own page. */
  function initRoot(root) {
    var moneyFormat = root.getAttribute('data-mms-money-format') || '{{amount}}';
    var currentPriceCents = parseInt(root.getAttribute('data-mms-current-price'), 10) || 0;
    var setPriceCents = parseInt(root.getAttribute('data-mms-set-price-cents'), 10) || 0;
    var showSavings = root.getAttribute('data-mms-show-savings') === 'true';

    var options = root.querySelectorAll('[data-mms-size-option]');
    var summaryEl = root.querySelector('[data-mms-summary]');
    var individualSumEl = root.querySelector('[data-mms-individual-sum]');
    var savingsEl = root.querySelector('[data-mms-savings]');
    var setPriceEl = root.querySelector('[data-mms-set-price]');

    if (!options.length) return;
    var ui = makeUi(root);
    if (!ui.addButton) return;

    var selectedPartner = null;

    bindSizePicker(root, function (option) {
      selectedPartner = option;
      updateState();
    });

    function updateState() {
      ui.addButton.disabled = !selectedPartner;

      if (!selectedPartner) {
        if (summaryEl) summaryEl.textContent = '';
        return;
      }

      if (summaryEl) {
        summaryEl.textContent = 'Größe ' + selectedPartner.title + ' ausgewählt';
      }

      var sum = currentPriceCents + selectedPartner.price;
      if (individualSumEl) individualSumEl.textContent = formatMoney(sum, moneyFormat);
      if (setPriceEl) setPriceEl.textContent = formatMoney(setPriceCents, moneyFormat);

      if (showSavings && savingsEl) {
        var savings = sum - setPriceCents;
        if (setPriceCents > 0 && savings > 0) {
          savingsEl.textContent = 'Du sparst ' + formatMoney(savings, moneyFormat);
          savingsEl.style.display = '';
        } else {
          savingsEl.textContent = '';
          savingsEl.style.display = 'none';
        }
      }
    }

    ui.addButton.addEventListener('click', function () {
      var currentVariantId = getCurrentVariantId();
      if (!currentVariantId || !selectedPartner) return;
      submitSetToCart(currentVariantId, selectedPartner.variantId, ui);
    });
  }

  /* Dual mode: standalone presentation product (e.g. "CORT SET"), two
     explicit size pickers, no native variant of its own involved. */
  function initDualRoot(root) {
    var moneyFormat = root.getAttribute('data-mms-money-format') || '{{amount}}';
    var setPriceCents = parseInt(root.getAttribute('data-mms-set-price-cents'), 10) || 0;
    var showSavings = root.getAttribute('data-mms-show-savings') === 'true';

    var blocks = root.querySelectorAll('[data-mms-product]');
    var summaryEl = root.querySelector('[data-mms-summary]');
    var individualSumEl = root.querySelector('[data-mms-individual-sum]');
    var savingsEl = root.querySelector('[data-mms-savings]');
    var setPriceEl = root.querySelector('[data-mms-set-price]');

    if (blocks.length < 2) return;
    var ui = makeUi(root);
    if (!ui.addButton) return;

    var selection = {};

    blocks.forEach(function (block) {
      var key = block.getAttribute('data-mms-product');
      bindSizePicker(block, function (option) {
        option.label = block.getAttribute('data-mms-label');
        selection[key] = option;
        updateState();
      });
    });

    function updateState() {
      var top = selection.top;
      var bottom = selection.bottom;
      var bothSelected = !!(top && bottom);
      ui.addButton.disabled = !bothSelected;

      if (!bothSelected) {
        ui.setIncomplete();
        if (summaryEl) summaryEl.textContent = '';
        return;
      }

      ui.setReady();

      if (summaryEl) {
        summaryEl.textContent = top.label + ' ' + top.title + ' · ' + bottom.label + ' ' + bottom.title;
      }

      var sum = top.price + bottom.price;
      if (individualSumEl) individualSumEl.textContent = formatMoney(sum, moneyFormat);
      if (setPriceEl) setPriceEl.textContent = formatMoney(setPriceCents, moneyFormat);

      if (showSavings && savingsEl) {
        var savings = sum - setPriceCents;
        if (setPriceCents > 0 && savings > 0) {
          savingsEl.textContent = 'Du sparst ' + formatMoney(savings, moneyFormat);
          savingsEl.style.display = '';
        } else {
          savingsEl.textContent = '';
          savingsEl.style.display = 'none';
        }
      }
    }

    ui.addButton.addEventListener('click', function () {
      if (ui.isSubmitting) return;
      var top = selection.top;
      var bottom = selection.bottom;
      if (!top || !bottom) return;
      submitSetToCart(top.variantId, bottom.variantId, ui);
    });
  }

  function init() {
    document.querySelectorAll('[data-mms-root]').forEach(function (root) {
      if (root.getAttribute('data-mms-mode') === 'dual') {
        initDualRoot(root);
      } else {
        initRoot(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
